import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { updateModalStatus } from "../../../actions/modals";
import { Div } from "../../atoms/Div";
import FailModal from "../../molecules/modals/FailModal";
import InfoModal from "../../molecules/modals/InfoModal";
import SuccessModal from "../../molecules/modals/SuccessModal";



export const AppModals = () => {

  const dispatch = useDispatch();
  const modalsr = useSelector((state) => state.modals, shallowEqual);

  const [modals, setModals] = useState({
    fail: { text: "", collapse: false },
    success: { text: "", collapse: false, withlink: false, linktype: "", linkto: "", linktext: "" },
    info: { text: "", collapse: false, withlink: false, linkto: "", linktext: "", icontype: "i" }
  })
  useEffect(() => {
    if (!modalsr.modalstatus.show) {
      clearModals();
    } else {
      manageModals();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalsr])

  const manageModals=()=>{
    switch (modalsr.modalstatus.type) {
      case "s":
        OpenModalSuccess(modalsr.modalstatus.text, modalsr.modalstatus.withlink,
          modalsr.modalstatus.linktype, modalsr.modalstatus.linkto, modalsr.modalstatus.linktext);
        break;

      case "i":
        OpenModalInfo(modalsr.modalstatus.text, modalsr.modalstatus.withlink,
          modalsr.modalstatus.linkto, modalsr.modalstatus.linktext, modalsr.modalstatus.icontype);
        break;

      case "f":
        OpenModalFail(modalsr.modalstatus.text);
        break;

      default:
        clearModals();
        break;
    }
  }

  const OpenModalFail = (text) => {
    setModals({
      fail: { text: text, collapse: true },
      success: { text: "", collapse: false, withlink: false, linktype: "", linkto: "", linktext: "" },
      info: { text: "", collapse: false, withlink: false, linkto: "", linktext: "", icontype: "i" }
    })
    setTimeout(() => closeModals(), 15000)
  }

  const OpenModalInfo = (text, withlink, linkto, linktext, icontype) => {
    setModals({
      fail: { text: "", collapse: false },
      success: { text: "", collapse: false, withlink: false, linktype: "", linkto: "", linktext: "" },
      info: { text: text, collapse: true, withlink: withlink, linkto: linkto, linktext: linktext, icontype: icontype }
    })
    setTimeout(() => closeModals(), 15000)
  }

  const OpenModalSuccess = (text, withlink, linktype, linkto, linktext) => {
    setModals({
      fail: { text: "", collapse: false },
      success: { text: text, collapse: true, withlink: withlink, linktype: linktype, linkto: linkto, linktext: linktext },
      info: { text: "", collapse: false, withlink: false, linkto: "", linktext: "", icontype: "i" }
    })
    setTimeout(() => closeModals(), 15000)
  }

  const clearModals = () => {
    setModals({
      fail: { text: "", collapse: false },
      success: { text: "", collapse: false, withlink: false, linktype: "", linkto: "", linktext: "" },
      info: { text: "", collapse: false, withlink: false, linkto: "", linktext: "", icontype: "i" }
    })
  }

  const closeModals = () => {
    let modalstatus = {
      show: false, withlink: false, linktype: "n", type: "", text: "", linkto: "", linktext: "", icontype: "",
    }
    dispatch(updateModalStatus(modalstatus));
  }

  return (
    <Div>
      <InfoModal info={modals.info} closeModals={closeModals}></InfoModal>
      <FailModal fail={modals.fail} closeModals={closeModals}></FailModal>
      <SuccessModal success={modals.success} closeModals={closeModals}></SuccessModal>
    </Div>
  );
};
